export default function HowItWorks() {
  const steps = [
    {
      title: "1. List Your Cards",
      desc: "Select the cards you currently own. No card numbers or bank logins required—ever.",
      icon: "💳"
    },
    {
      title: "2. Describe Your Spend",
      desc: "Tell us where your money goes. Dining? Travel? Online shopping? Be as specific as you like.",
      icon: "📊"
    },
    {
      title: "3. AI Audit",
      desc: "Our AI engine (Sift) cross-references your spend against real-time reward point values and lounge access rules.",
      icon: "🤖"
    },
    {
      title: "4. Get Your Roadmap",
      desc: "Receive an instant breakdown of which card to use for every category to maximize your cash-back and miles.",
      icon: "🚀"
    }
  ];

  return (
    <div className="bg-slate-900 min-h-screen text-white pb-20">
      <div className="max-w-5xl mx-auto px-4 pt-20">
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-extrabold mb-4">Simple. Fast. Secure.</h1>
          <p className="text-slate-400 text-xl">Go from 'Confused' to 'Optimized' in under 60 seconds.</p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="bg-slate-800/30 p-8 rounded-3xl border border-slate-700 hover:border-blue-500/50 transition-colors group">
              <div className="text-4xl mb-4 group-hover:scale-110 transition-transform inline-block">
                {step.icon}
              </div>
              <h3 className="text-2xl font-bold mb-2">{step.title}</h3>
              <p className="text-slate-400 leading-relaxed">{step.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-20 bg-gradient-to-r from-blue-600/20 to-emerald-600/20 p-10 rounded-3xl border border-blue-500/20 text-center">
          <h2 className="text-3xl font-bold mb-4">Ready to find your hidden rewards?</h2>
          <a href="/" className="inline-block bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-full font-bold text-lg transition-all shadow-xl shadow-blue-500/20">
            Start Your Free Audit →
          </a>
        </div>
      </div>
    </div>
  );
}
